<template>
  <div class="text-muted inline-flex items-center gap-2 text-sm">
    <!-- Must be inline to inherit the text color -->
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Upmind logo"
    >
      <path
        d="M6.49503 7.75818C6.06979 7.18695 5.41376 6.95744 4.70226 6.93576C4.1782 6.92046 3.44248 7.04733 2.63918 7.64151C2.28088 7.90609 1.96976 8.22932 1.70518 8.58762L0.745677 9.8882C-0.505817 11.5841 -0.144969 13.9729 1.55025 15.2238C1.56747 15.2365 1.58532 15.2493 1.60253 15.262C3.34366 16.5122 5.76568 16.1361 7.04523 14.4166L9.20968 11.4833L6.49375 7.75818H6.49503Z"
        fill="currentColor"
      />
      <path
        d="M19.2773 9.91474C19.271 9.90581 19.2639 9.89688 19.2576 9.88732L13.1499 1.5904C12.7546 1.05359 12.2261 0.629629 11.6173 0.359313C11.6045 0.359313 11.6045 0.346562 11.5911 0.346562C11.5395 0.320423 11.5006 0.307672 11.4483 0.282808C11.4356 0.282808 11.4222 0.270057 11.3967 0.270057C11.3514 0.258582 11.3074 0.241368 11.2666 0.219054C11.2539 0.219054 11.2277 0.206303 11.215 0.206303C11.1761 0.193553 11.1372 0.180164 11.0849 0.167414C11.0722 0.167414 11.046 0.154663 11.0333 0.154663C10.9816 0.141912 10.9421 0.128524 10.8905 0.115773C10.8758 0.117048 10.8618 0.111948 10.8516 0.101747C10.7999 0.0889964 10.7349 0.0768831 10.6826 0.0634948C9.6377 -0.126492 8.56025 0.11386 7.69511 0.730997C7.41842 0.927359 7.16914 1.1607 6.95492 1.42336C6.91603 1.46735 6.88161 1.51453 6.851 1.56426L6.83825 1.57701L3.33496 6.37767C3.71494 6.12457 4.39711 5.7599 5.16152 5.77265C5.80416 5.76245 6.45318 5.96965 6.98999 6.40764C7.1328 6.52431 7.26413 6.655 7.38208 6.79717L10.0068 10.4005L12.9574 14.4151C14.242 16.1269 16.657 16.5024 18.4007 15.2618C20.1195 14.0269 20.5122 11.6329 19.2773 9.91346V9.91474Z"
        fill="currentColor"
      />
    </svg>
    <span>
      {{ t("text.powered_by") }}
      <Link
        size="inherit"
        color="inherit"
        href="https://upmind.com"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-block underline underline-offset-2"
        >Upmind</Link
      >
    </span>
  </div>
</template>

<script lang="ts" setup>
// --- external
import { useI18n } from "vue-i18n";

// --- internal
import { Link } from "@upmind-automation/upmind-ui";

const { t } = useI18n();
</script>
